'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" o "//" (URL relativa al protocolo).
  // RFC 3986 define el nombre de esquema como una secuencia de caracteres que comienza con una letra y va seguida
  // por cualquier combinación de letras, dígitos, signo más, punto o guión.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
</scheme>